import { MBProductType } from "web/types/Product";

const isSubscription = (productType: MBProductType) =>
  typeof productType === "string" && productType.includes("abonament");

export default isSubscription;
